module.exports = __webpack_public_path__ + "img/cart.99baf626.svg";